import pathOr from 'ramda/src/pathOr'
import has from 'ramda/src/has'
import compose from 'ramda/src/compose'

export default compose(has('email'), pathOr({}, ['app', 'userData', 'payoutMethod']))
